<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-export`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.8125 10.887C12.1797 10.8871 12.4775 11.1848 12.4775 11.552C12.4773 11.919 12.1795 12.2169 11.8125 12.217H2.1875C1.82037 12.217 1.52268 11.9191 1.52246 11.552C1.52246 11.1847 1.82023 10.887 2.1875 10.887H11.8125ZM7.00098 1.22974C7.36884 1.23013 7.66797 1.52878 7.66797 1.89673V7.63892L9.81836 5.48853C10.0787 5.22834 10.5004 5.22831 10.7607 5.48853C11.0207 5.74889 11.0209 6.17167 10.7607 6.43188L8.22656 8.96606C8.10251 9.09012 7.98059 9.21209 7.87012 9.30591C7.75371 9.40471 7.60581 9.51172 7.41309 9.57446C7.14543 9.66143 6.85557 9.66134 6.58789 9.57446C6.39532 9.51181 6.24724 9.40463 6.13086 9.30591C6.02051 9.21219 5.89831 9.08996 5.77441 8.96606L3.24023 6.43188C2.9799 6.17155 2.97992 5.74888 3.24023 5.48853C3.50059 5.22821 3.92326 5.22819 4.18359 5.48853L6.33398 7.63892V1.89673C6.33398 1.52854 6.63279 1.22974 7.00098 1.22974Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineExport',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
